
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/smart-chains/setup/smart-chain-maintenance",
      function () {
        return require("private-next-pages/docs/smart-chains/setup/smart-chain-maintenance/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/smart-chains/setup/smart-chain-maintenance"])
      });
    }
  